var _ = require('underscore/underscore.js');
var Base = require('front/components/Base/Base');

var template = require('./MyADGScreenings.jinja');
require('./MyADGScreenings.less');

var MyADGScreeningsInner = require('front/components/MyADGScreenings/MyADGScreeningsInner');

var MyADGScreeningsTemplate = require('front/components/MyADGScreenings/MyADGScreeningsInnerRuntime.jinja');

module.exports = Base.extend({

    template: template,

    events: {
        'click .MyADGScreenings-showMoreButton': 'onClickMoreButton'
    },

    moreApi: function () {
        return this.state.next;
    },

    //Base creates an instances for each one of found dom nodes (by selector) when parent view is rendered itself
    VIEWS_TO_REGISTER: {
        'MyADGScreeningsInner': {selector: '.MyADGScreeningsInner', viewConstructor: MyADGScreeningsInner}
    },


    initialize: function (options) {
        this.options = options || {};

        _.bindAll(this, 'moreApi');

        var limit = 5;

        this.state = {
            next: Urls['front:api:my_adg_screenings']() + '?offset=' + this.$('.MyADGScreeningsInner-item').size(),
            hasMore: false
        };

        Base.prototype.initialize.call(this, options);
    },


    onClickMoreButton: function (e) {
        var self = this;
        this.$('.MyADGScreenings-showMoreButton').addClass('Button--loading');

        this.forceLoadData(this.moreApi)
            .then(function () {
                self.state.next = self.data.next;
                var $screenings = $(MyADGScreeningsTemplate.render({data: self.data.results}));
                self.state.hasMore = !!self.state.next;

                self.$('.MyADGScreenings-listWrapper').append($screenings);

                app.animateShowMoreSlideDown({$items: $screenings, hasWrapper: true});

                self.$('.MyADGScreenings-showMoreButton')
                    .toggle(!!self.state.hasMore)
                    .removeClass('Button--loading');

                new MyADGScreeningsInner({
                    el: $screenings[0]
                });
            });
    }
});



//////////////////
// WEBPACK FOOTER
// ./assets/app/front/components/MyADGScreenings/MyADGScreenings.js
// module id = 229
// module chunks = 0